/* eslint-disable */
import React, { useState } from 'react';
import { Button, Flex, Form, Input, Typography } from 'antd';
import { Container } from '@material-ui/core';
import { SNBL_PATH } from 'src/configs/AppConfig';
import useAppSearchParams from 'src/hooks/useAppSearchParams';
import { useNavigate } from 'react-router-dom';
import useAppMutation from 'src/hooks/useAppMutation';
import { COLOR_3 } from 'src/constants/ChartConstant';
import getErrorMessage from 'src/utils/getError';
import upperFirst from 'lodash/upperFirst';
import { ICreateSNBLWalletPinPayload } from './types';
import { SNBLNav } from './snbl-nav';

const PIN_LENGTH = 4;

export const SNBLPinCreation: React.FC = () => {
  const [form] = Form.useForm<ICreateSNBLWalletPinPayload>();
  const navigate = useNavigate();
  const { queryParamsObject, searchParamsString } = useAppSearchParams();

  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');

  const pinValid = pin !== '' && confirmPin !== '' && pin === confirmPin;

  const initialValues = {
    userId: queryParamsObject.userId,
    walletClass: 'customer',
    pin: '',
  };

  const {
    error,
    isPending,
    mutate: createWalletPinMutate,
  } = useAppMutation<ICreateSNBLWalletPinPayload>('/users/v1/self/createSNBLPin', {
    onSuccess: () => {
      navigate(`${SNBL_PATH}/account-creation-successful?${searchParamsString}`);
    },
  });

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        if (pinValid) {
          createWalletPinMutate({ ...initialValues, ...values });
        }
      })
      .catch((info) => {});
  };

  return (
    <main className="d-flex justify-content-between flex-column">
      <SNBLNav />
      <Container maxWidth="sm">
        <Flex align="center" gap={12} className="mb-4">
          <div style={{ width: 'max-content' }}>
            <Typography.Title level={5}>Save Now, Buy Later with {upperFirst(queryParamsObject.merchantId)}</Typography.Title>
            <Typography style={{ textAlign: 'right' }}>powered by AjoCard</Typography>
          </div>
        </Flex>
        <Typography.Text>Kindly create your 4-digit pin to protect your account</Typography.Text>
        <Form form={form} className="mt-5" initialValues={initialValues} layout="vertical" name="snpl-form" onFinish={onSubmit}>
          <Form.Item hasFeedback name="pin" label="Enter Pin">
            <Input.OTP value={pin} mask={'🔒'} onChange={setPin} style={{ width: '200px' }} length={PIN_LENGTH} itemType="number" />
          </Form.Item>
          <Form.Item hasFeedback name="confirmPin" label="Confirm Pin">
            <Input.OTP value={confirmPin} mask={'🔒'} onChange={setConfirmPin} style={{ width: '200px' }} length={PIN_LENGTH} itemType="number" />
          </Form.Item>
          <Button loading={isPending} htmlType="submit" disabled={!pinValid}>
            Submit
          </Button>
        </Form>
        <p style={{ color: COLOR_3 }}>{error && getErrorMessage(error)}</p>
      </Container>
    </main>
  );
};

export default SNBLPinCreation;
